import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { ButtonIconComponent } from "@ui/controls/button-icon/button-icon.component";
import { LanguagesComponent } from "../../../components/languages/languages.component";
import { NotificationEvent } from "./notifications-panel/notification-item/types";
import { NotificationsPanelComponent } from "./notifications-panel/notifications-panel.component";

@Component({
  selector: "lc-header-icons",
  templateUrl: "./header-icons.component.html",
  styleUrl: "./header-icons.component.scss",
  imports: [
    LanguagesComponent,
    NotificationsPanelComponent,
    ButtonIconComponent,
    TranslatePipe,
  ],
})
export class HeaderIconsComponent {
  private router = inject(Router);

  @Input() public isUserLoggedIn = false;
  @Input() public newMessages = false;
  @Input() public hasNotifications = false;
  @Input() public notifications: NotificationEvent[] = [];
  @Output() public markNotificationAsReadEvent =
    new EventEmitter<NotificationEvent>();

  protected notificationsOpen = false;

  goToFaqs(): void {
    this.router.navigate(["/faq"]);
  }

  toggleNotifications(): void {
    this.notificationsOpen = !this.notificationsOpen;
  }

  closeNotifications(): void {
    this.notificationsOpen = false;
  }

  markNotificationAsRead(notification: NotificationEvent): void {
    this.markNotificationAsReadEvent.emit(notification);
  }
}
